interface IData {
  countries: ICountry[];
  states: IState[];
}

/**
 * Transform given from server data into dropdown options
 *
 * @returns An array of country and states options containing value (id) and label (name).
 */
export const getCountriesAndStatesOptions = (data: IData | undefined) => {
  if (!data) return { countryOptions: [], stateOptions: [] };

  return {
    countryOptions: data.countries.map(({ id, name }) => ({
      value: id,
      label: name,
    })),

    stateOptions: data.states.map(({ id, name }) => ({
      value: id,
      label: name,
    })),
  };
};
